import { render, staticRenderFns } from "./upLoad.vue?vue&type=template&id=76bbdbc1&scoped=true&"
import script from "./upLoad.vue?vue&type=script&lang=js&"
export * from "./upLoad.vue?vue&type=script&lang=js&"
import style0 from "./upLoad.vue?vue&type=style&index=0&id=76bbdbc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bbdbc1",
  null
  
)

export default component.exports